import { render, staticRenderFns } from "./colorThemeSelector.vue?vue&type=template&id=6548c270&"
import script from "./colorThemeSelector.vue?vue&type=script&lang=js&"
export * from "./colorThemeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6548c270')) {
      api.createRecord('6548c270', component.options)
    } else {
      api.reload('6548c270', component.options)
    }
    module.hot.accept("./colorThemeSelector.vue?vue&type=template&id=6548c270&", function () {
      api.rerender('6548c270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/colorThemeSelector.vue"
export default component.exports